import _ from 'lodash';
import $ from 'jquery';
import Events from '../../_utils/events.js';

class View extends Events {

	constructor (tpl, data, options) {
		super(tpl, data, options);

		options = options || {};

		this.template = _.template(
			`<div class="${options.viewClass || ''}">
				${tpl}
			</div>`
		);

		this._childTemplate = _.template(tpl);

		this.data = data;
		this.options = options;
	}

	render(data) {
		data = data || this.data;

		if (this.$el) {
			this.$el.children().remove();
			this.$el.append($(this._childTemplate({data: data})));
		} else {
			this.$el = $(this.template({data: data}));
		}

		this._setUiElements(this.uiElements());
		this.initializeEvents();
	}

	//TODO: improve how uiElements are extended
	uiElements() {
		return {};
	}

	_setUiElements(elements) {
		this.ui = {};
		_.each(elements, (selector, key) => {
			this.ui[key] = this.$el.find(selector);
		});
	}

	show($container) {
		$container.empty();
		return this.appendTo($container);
	}

	appendTo($el) {
		if (!this.$el) {
			this.render();
		}

		$el.append(this.$el);

		this.onShow();
	}

	onShow() {}
	initializeEvents() {}

	detach() {
		this.$el.detach();
	}

	remove() {
		this.$el.remove();
		this.$el = undefined;
	}


}

export default View;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/_components/view/view.js